import { Partner } from './partner.model';
import { SDiContact } from './sdi-contact.model';

export type UserRole = 'admin' | 'partner';
export type UserType =
  | 'Referenciador'
  | 'Distribuidor'
  | 'Partner Estratégico'
  | 'Colaborador'
  | 'Administrador';

export const USER_TYPE_OPTIONS: { label: string; value: UserType }[] = [
  { label: 'Referenciador', value: 'Referenciador' },
  { label: 'Distribuidor', value: 'Distribuidor' },
  { label: 'Partner Estratégico', value: 'Partner Estratégico' },
  { label: 'Colaborador', value: 'Colaborador' },
  { label: 'Administrador', value: 'Administrador' },
];

export interface User {
  id: string;
  name: string;
  email: string;
  phone?: string;
  company?: string;
  partner_id?: number;
  partner?: Partner;
  sdi_contact?: SDiContact;
  roles: UserRole[];
  created_at: string;
  updated_at: string;
  opportunities?: number; // Campo adicional para mostrar número de oportunidades
  active: boolean; // Campo para estado activo/inactivo
  type?: UserType; // Tipo de partner
  invitation_sent_at?: string | null; // Campo para fecha de envío de invitación
  email_verified_at?: string | null; // Campo para fecha de verificación de correo
}
